import { isInApp, setAccessToken } from "@/libs/comeAppSDK";

export const setAuthToken = async (token: string) => {
  if (!token || token.trim() === '') {
    return;
  }
  localStorage.setItem('accessToken', token);
  if (isInApp()) {
    await setAccessToken(token);
  }
};

export const clearAuthCookies = async () => {
  try {
    await fetch('/api/clear-auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    });
  } catch (error) {
    console.error('Failed to clear auth cookies:', error);
    // 即使清除 cookie 失败，也不影响登出流程
  }
};